///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users = abcsetup.users || {};
abcsetup.users.index = abcsetup.users.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users.index = {
    init: function () {
        abcsetup.setTitle(abcsetup.userRole.class == 'private_label_team' || abcsetup.userRole.class === 'fs_cm' ? 'Supplier Invitations' : 'Manage Users');

        // When invitation status toggle changes, update the data in the table.
        $(document).on('change', '.consumer_rfp_invitation_status_toggle', event => {
            abcsetup.blockUI(true);
            window.location.href = '/users/?status='  + $(event.target).val();
        });

        if (!$('#reinstate-roles-modal').length) {
            $('body').append(`
                <div class="modal fade" id="reinstate-roles-modal" tabindex="-1" role="dialog" aria-labelledby="reinstate-roles-modal-label" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header" id="reinstate-roles-modal-header">
                                <h5 class="modal-title" id="reinstate-roles-modal-label"></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" id="reinstate-roles-modal-body">
                                <p id="reinstate-roles-modal-text">Select the roles you wish to reinstate:</p>
                                <div id="reinstate-roles-checkbox-list"></div>
                            </div>
                            <div class="modal-footer" id="reinstate-roles-modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-success" id="confirm-reinstate-roles">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }

        $(document).on('click', '#confirm-reinstate-user-button', function() {
            const id = $(this).data('id');
            const name = $(this).data('name');
            const roles = $(this).data('roles');
        
            $('#reinstate-roles-checkbox-list').empty();
            $('#reinstate-roles-modal-body').empty();
        
            if (roles.length === 0) {
                // No roles available
                $('#reinstate-roles-modal-label').text('Reinstate User');
                $('#reinstate-roles-modal-body').html(`<p>Are you sure you want to reinstate ${name}?</p>`);
                $('#confirm-reinstate-roles').text('Confirm');
            } else if (roles.length === 1) {
                // Only one role available
                const role = roles[0];
                $('#reinstate-roles-modal-label').text('Reinstate User');
                $('#reinstate-roles-modal-body').html(`
                    <p>Are you sure you want to reinstate ${name} as:</p>
                    <p>${role.name}</p>
                `);
                $('#confirm-reinstate-roles').text('Confirm');
            } else {
                // Multiple roles available
                $('#reinstate-roles-modal-label').text('Reinstate User');
                const rolesCheckboxes = roles.map(function(role) {
                    return `
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="${role.id}" id="role${role.id}">
                            <label class="form-check-label" for="role${role.id}">
                                ${role.name}
                            </label>
                        </div>
                    `;
                }).join('');
        
                $('#reinstate-roles-modal-body').html(`
                    <p id="reinstate-roles-modal-text">Select the roles you wish to reinstate:</p>
                    <div id="reinstate-roles-checkbox-list">
                        ${rolesCheckboxes}
                    </div>
                `);
                $('#confirm-reinstate-roles').text('Confirm');
            }
        
            // Store user ID and roles in the confirm button's data attributes
            $('#confirm-reinstate-roles').data('id', id);
            $('#confirm-reinstate-roles').data('roles', roles);
            
            $('#reinstate-roles-modal').modal('show');
        });
        
        $(document).on('click', '#confirm-reinstate-roles', function() {
            const id = $(this).data('id');
            const roles = $(this).data('roles'); 
            const selectedRoleIds = [];
        
            // If there are checkboxes, gather the selected role IDs
            if (roles.length > 1) {
                $('#reinstate-roles-modal .form-check-input:checked').each(function() {
                    selectedRoleIds.push($(this).val());
                });

                // If multiple roles are available but none selected, show an alert
                if (selectedRoleIds.length === 0) {
                    alert('Please select at least one role to reinstate.');
                    return;
                }
            } else if (roles.length === 1) {
                selectedRoleIds.push(roles[0].id);
            }

            const roleIdsToSend = selectedRoleIds.length ? selectedRoleIds.join(',') : '';

            abcsetup.blockUI(true);
            axios.post('/users/reinstate', {
                user_id: id,
                role_ids: roleIdsToSend
            }).then(function(response) {
                if (response.status === 200) {
                    window.location.href = '/users';
                }
                abcsetup.unblockUI();
            });
        });

        $('#reinstate-roles-modal').on('hidden.bs.modal', function () {
            $('#reinstate-roles-checkbox-list').empty();
            $('#reinstate-roles-modal-body').empty();
            $('#reinstate-roles-modal-label').text('');
            $('#confirm-reinstate-roles').removeData('roles');
        });
    },

    /**
     * yajra datatable draw callback
     */
    tableDrawCallback: function() {
        if (abcsetup.userRole.class === 'private_label_team' || abcsetup.userRole.class === 'fs_cm') {
            $('button.buttons-create span').html('<i class="fa fa-plus"></i> Invite Supplier');
        }
    },
}
